import { Button } from 'components/UI';

type SelectableOptionProps = {
  optionValue: string | undefined;
  optionName: string;
  selectOption: (arg0: string) => void | undefined;
  selected?: boolean | undefined;
};

const SelectableOption = ({ optionValue, optionName, selectOption, selected }: SelectableOptionProps) => {
  const selectOptionLocal = () => {
    let value = '';

    if (optionValue !== undefined) {
      value = optionValue;
    }
    if (value === '') {
      value = optionName;
    }

    selectOption(value);
  };

  return (
    <Button
      onClick={() => selectOptionLocal()}
      w="98%"
      variant={selected ? 'outline' : 'unstyled'}
      size="sm"
      sx={{
        _focus: {
          boxShadow: 'none',
        },
      }}
      borderWidth={1}
      letterSpacing="inherit"
      color={!selected ? 'primaryFontColour.500' : 'primaryThemeColour.400'}
    >
      {optionName}
    </Button>
  );
};

export default SelectableOption;
